


import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'
import { ElEContractorNameDDLAPI, ElEProjectWiseContractorDDLAPI, Get_DDL_M_Contractor_Grid_SelectDDLAPI } from '../../Redux/DDLSlice'

export const MasterContractorNameDDL = (props) => {
    const { ContractorName, setContractorName, M_ProjectID, M_ContractorID, rowData, Flag, IsPost, APIFlag, M_ProjectTypeID } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    // console.log('rowData', rowData)

    useEffect(() => {
        const data = {
            M_ProjectTypeID: M_ProjectTypeID,
            M_ProjectID: M_ProjectID,
            M_ContractorID: M_ContractorID,
            Flag: APIFlag,
            M_UserID: UserID,
            token: token
        }
        dispatch(Get_DDL_M_Contractor_Grid_SelectDDLAPI({ data }))
    }, [IsPost, M_ProjectTypeID, M_ProjectID, M_ContractorID, APIFlag])

    const { ContractorNameDDLData } = useSelector(state => state.Get_DDL_M_Contractor_Grid_SelectDDLData)
    const key = (APIFlag || '').trim()
    const currentDDLData = ContractorNameDDLData?.[key]
    useEffect(() => {
        handleContractorNameDDL()
    }, [currentDDLData])

    const handleContractorNameDDL = () => {
    if (currentDDLData && currentDDLData.table && currentDDLData.table.length > 0) {
        let list = currentDDLData.table.map((item) => ({
            value: item.m_ContractorID,
            label: item.contractorName,
        }))

        setContractorName({
            DDL: list,
            ID: Flag == 'Update' ? rowData.contractorNameID : 0,
            Label: Flag == 'Update' ? rowData.contractorName : "Select...",
        })
    } else {
        setContractorName({
            DDL: [],
            ID: 0,
            Label: "Select...",
        })
    }
}


    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Contractor Name {Flag && <AstricSign />} </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: ContractorName.ID, label: ContractorName.Label }}
                onChange={(e) => {
                    e ?
                        setContractorName({ ...ContractorName, ID: e.value, Label: e.label })
                        :
                        setContractorName({ ...ContractorName, ID: 0, Label: "Select..." })

                }}
                options={ContractorName.DDL}
            />
        </div>
    )
}